
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tables/book/[restaurant]",
      function () {
        return require("private-next-pages/tables/book/[restaurant].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tables/book/[restaurant]"])
      });
    }
  